module.exports = __webpack_public_path__ + "19eb36102303d6383bb9f826301c5f12.svg";